module.exports = __webpack_public_path__ + "static/shape-left-13fa8b3d988ca4eb9d7c2da935c2d73a.png";